import { Navbar } from "../components/Navbar";
import { Link } from "react-router-dom";
import { Shield, Mail } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border p-8 sm:p-12">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-100 rounded-full mb-4">
              <Shield className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
            <p className="text-slate-500 mt-2">
              Informativa sul trattamento dei dati personali
            </p>
            <p className="text-xs text-slate-400 mt-2">
              Conforme alla Legge federale sulla protezione dei dati (LPD) - Revisione 2023
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 text-sm mb-6">
              Ultimo aggiornamento: Gennaio 2026
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">1. Titolare del Trattamento</h2>
              <div className="bg-slate-50 p-4 rounded-lg">
                <p className="text-slate-700 mb-2"><strong>Darko Vidakovic</strong></p>
                <p className="text-slate-600 text-sm">6945 Origlio, Ticino, Svizzera</p>
                <p className="text-slate-600 text-sm">Email: info@lavoroticino.ch</p>
                <p className="text-slate-600 text-sm">Tel: +41 78 614 18 54</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">2. Dati Personali Raccolti</h2>
              <p className="text-slate-700 mb-3">
                Raccogliamo i seguenti dati personali necessari per l'erogazione del servizio:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li><strong>Dati identificativi:</strong> Nome, cognome, età</li>
                <li><strong>Dati di contatto:</strong> Indirizzo email, numero di telefono</li>
                <li><strong>Dati di localizzazione:</strong> Comune di residenza (Canton Ticino)</li>
                <li><strong>Dati professionali:</strong> Settore lavorativo, competenze, esperienze</li>
                <li><strong>Dati linguistici:</strong> Lingue parlate e relativo livello</li>
                <li><strong>Stato autorizzativo:</strong> Tipo di permesso di soggiorno (G, B, C, Svizzero)</li>
                <li><strong>Dati tecnici:</strong> Indirizzo IP, tipo di browser (per sicurezza e statistiche aggregate)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">3. Finalità del Trattamento</h2>
              <p className="text-slate-700 mb-3">
                I dati personali vengono trattati per le seguenti finalità:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li><strong>Esecuzione del servizio:</strong> Gestione della bacheca annunci e del sistema di messaggistica interna</li>
                <li><strong>Creazione del profilo:</strong> Pubblicazione del profilo candidato o annuncio aziendale</li>
                <li><strong>Comunicazioni:</strong> Invio di notifiche relative al servizio (nuovi messaggi, candidature)</li>
                <li><strong>Statistiche anonime:</strong> Analisi aggregate del traffico tramite Umami Analytics (senza cookie di profilazione)</li>
                <li><strong>Sicurezza:</strong> Prevenzione di abusi e frodi</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">4. Base Giuridica</h2>
              <p className="text-slate-700">
                Il trattamento dei dati si basa su:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-3">
                <li><strong>Esecuzione contrattuale:</strong> Il trattamento è necessario per fornire il servizio richiesto (art. 6 par. 1 lett. b LPD)</li>
                <li><strong>Consenso:</strong> Per l'invio di comunicazioni promozionali (revocabile in ogni momento)</li>
                <li><strong>Interesse legittimo:</strong> Per la sicurezza della piattaforma e le statistiche aggregate</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">5. Conservazione dei Dati</h2>
              <p className="text-slate-700 mb-3">
                I dati personali vengono conservati secondo i seguenti criteri:
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <ul className="text-slate-700 space-y-2 text-sm">
                  <li>• <strong>Account attivi:</strong> Per tutta la durata dell'utilizzo del servizio</li>
                  <li>• <strong>Account inattivi:</strong> <strong>24 mesi</strong> dall'ultima attività, dopodiché i dati vengono anonimizzati o eliminati</li>
                  <li>• <strong>Dati di fatturazione:</strong> 10 anni come richiesto dalla normativa fiscale svizzera</li>
                  <li>• <strong>Log di sicurezza:</strong> 12 mesi</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">6. Condivisione dei Dati</h2>
              <p className="text-slate-700 mb-3">
                I dati personali <strong>non vengono venduti</strong> a terzi. Possono essere condivisi con:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li><strong>Altri utenti:</strong> I dati del profilo sono visibili agli altri utenti della piattaforma secondo le impostazioni di privacy scelte</li>
                <li><strong>Fornitori tecnici:</strong> Hosting, elaborazione pagamenti (Stripe), analytics (Umami) - tutti soggetti a DPA</li>
                <li><strong>Autorità:</strong> Solo se richiesto per legge o ordine giudiziario</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">7. Cookie e Tecnologie Simili</h2>
              <p className="text-slate-700 mb-3">
                La piattaforma utilizza:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li><strong>Cookie tecnici essenziali:</strong> Per il funzionamento del sito (sessione, autenticazione)</li>
                <li><strong>Umami Analytics:</strong> Servizio di analisi <strong>senza cookie di profilazione</strong>, rispettoso della privacy</li>
              </ul>
              <p className="text-slate-600 text-sm mt-3">
                Non utilizziamo cookie pubblicitari o di tracciamento di terze parti.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">8. Diritti dell'Utente</h2>
              <p className="text-slate-700 mb-3">
                Ai sensi della LPD Svizzera, l'utente ha diritto a:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  { title: "Accesso", desc: "Ottenere conferma e copia dei dati" },
                  { title: "Rettifica", desc: "Correggere dati inesatti" },
                  { title: "Cancellazione", desc: "Richiedere la cancellazione" },
                  { title: "Portabilità", desc: "Ricevere i dati in formato standard" },
                  { title: "Opposizione", desc: "Opporsi al trattamento" },
                  { title: "Revoca consenso", desc: "Revocare il consenso dato" },
                ].map((right, i) => (
                  <div key={i} className="bg-slate-50 p-3 rounded-lg">
                    <p className="font-semibold text-slate-800 text-sm">{right.title}</p>
                    <p className="text-slate-600 text-xs">{right.desc}</p>
                  </div>
                ))}
              </div>
              <div className="mt-4 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
                <p className="text-emerald-800 text-sm">
                  <Mail className="w-4 h-4 inline mr-2" />
                  Per esercitare i tuoi diritti, scrivi a: <strong>info@lavoroticino.ch</strong>
                </p>
                <p className="text-emerald-700 text-xs mt-1">
                  Risponderemo entro 30 giorni dalla richiesta.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">9. Sicurezza</h2>
              <p className="text-slate-700">
                Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali, 
                inclusa la crittografia SSL/TLS per tutte le comunicazioni, l'hashing delle password 
                e backup regolari.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-slate-900 mb-4">10. Modifiche alla Privacy Policy</h2>
              <p className="text-slate-700">
                Ci riserviamo il diritto di modificare questa informativa. Le modifiche sostanziali 
                verranno comunicate via email o tramite avviso sul sito. La data dell'ultimo 
                aggiornamento è indicata in alto.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">11. Contatti e Reclami</h2>
              <p className="text-slate-700 mb-3">
                Per qualsiasi domanda relativa alla privacy:
              </p>
              <div className="bg-slate-50 p-4 rounded-lg text-sm">
                <p className="text-slate-700"><strong>Email:</strong> info@lavoroticino.ch</p>
                <p className="text-slate-700 mt-1"><strong>Telefono:</strong> +41 78 614 18 54</p>
              </div>
              <p className="text-slate-600 text-sm mt-3">
                In caso di insoddisfazione, è possibile presentare reclamo all'<strong>Incaricato 
                federale della protezione dei dati e della trasparenza (IFPDT)</strong>.
              </p>
            </section>
          </div>

          {/* Footer links */}
          <div className="mt-10 pt-6 border-t flex flex-wrap gap-4 text-sm">
            <Link to="/impressum" className="text-[#004E64] hover:underline">Impressum</Link>
            <Link to="/terms" className="text-[#004E64] hover:underline">Termini e Condizioni</Link>
            <Link to="/" className="text-slate-500 hover:text-slate-700">← Torna alla home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
